import React, { useState,useEffect,useMemo,useRef } from 'react';
import axios from 'axios';
import config from '../config/config';
import {  
  Search, 
  Home, 
  Loader2,
  Package, 
  ShoppingCart, 
  Users, 
  BarChart3, 
  Settings, 
  FileText,
  Bell, 
  Menu,
  Sparkles,
  Crown,
  ArrowRight,
  Plus,
  TrendingUp,
  DollarSign,
  Eye,
  Edit,
  Trash2,
  Filter,
  Download,
  Upload,
  MoreHorizontal,
  ChevronLeft, 
  ChevronRight,
  Star,
  AlertCircle,
  X,
  Truck,
  Tag,
  Zap,
  Award,
  Percent,
  LifeBuoy,
  HelpCircle,
  BookOpen,
  Monitor,
  UserCheck,
  Layers,
  Shield
} from 'lucide-react';

const EcommerceBackend = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeTab, setActiveTab] = useState('overview');
  const [stats, setDashboardReports]=useState([]);
  const [loading, setLoading] = useState(true);
  const [mainloading, setMainLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [managementTypes, setManagementTypes]=useState([]);
  const [settingsManagement, setsettingsManagement]=useState([]);
  const [websiteManagement, setwebsiteManagement]=useState([]);
  const [orderManagement, setorderManagement]=useState([]);
  const [userManagement, setuserManagement]=useState([]);
  const [financeManagement, setfinanceManagement]=useState([]);
   const [filterCategory, setFilterCategory] = useState('all');
  const [filterPrice, setFilterPrice] = useState([0, 10000]);
  const [filterBrand, setFilterBrand] = useState('all');
const API_URL = `${config.API_URL}/api`;
  const [isMobile, setIsMobile] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [product_categories, setProductCategories]=useState([]);

  const [productModal, setProductModal] = useState(null);
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages2, setTotalPages] = useState(1);
  const [searchResults, setSearchResults] = useState([]);

  const token = localStorage.getItem('token');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const tableRef = useRef(null);
  const iconMap = {
  Package,
  ShoppingCart,
  Users,
  BarChart3,
  Star,
  Settings,
  Bell,
  TrendingUp,
  Upload,
  Download,
  AlertCircle,
  MoreHorizontal,
  DollarSign,
  Truck,
  Tag,
  Zap,
  Award,
  Percent,
  LifeBuoy,
  HelpCircle,
  BookOpen,
  Monitor,
  UserCheck,
  Shield,
  Edit,
  Layers
};

const setFilterSearchQuery = (searchKey) => {
  setSearchQuery(searchKey);
  if(activeTab=='product_categories'){
    setActiveTab('product_categories');
    pullCategories('all',searchKey);
  }
}


const filterActiveTab = (label) => {
  if(label=='Categories'){
    setActiveTab('product_categories');
    pullCategories();
  }

  if(label=='Products' || activeTab=="product_view"){
    setActiveTab('product_view');
    pullCategories();
    pullProducts();
  }
}



 const filteredCategories = useMemo(() => {
   return product_categories;
}, [product_categories]);

  const totalPages = Math.ceil(filteredCategories.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedCategories = filteredCategories.slice(startIndex, startIndex + itemsPerPage);

const editCategory = (id) => {
  window.location.assign(config.API_URL+'/editCategory/'+id);
}

const getChildCategories = (id) =>{
   pullCategories(id);
}

const deleteCategory = (id) => {

}


const pullProducts = async(category_id='',searchKey='') => {
    setLoading(true);
    try {
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const params = { page, limit: 20 };
        if (selectedCategory !== 'all') {
          params.category_id = selectedCategory;
        }
        const response = await axios.get(`${API_URL}/products`, { params, headers });
        setProducts(response.data.data);
        setTotalPages(response.data.meta.last_page);
     setLoading(false);
      
    } catch (err) {
      console.error('Error fetching reports:', err);
    } finally {
      setLoading(false);
    }
}

// Update filtered products for View All Modal
  const filteredViewAllProducts = products.filter(p => {
    const inCategory = filterCategory === 'all' || p.category_id === parseInt(filterCategory);
    const inPrice = p.price >= filterPrice[0] && p.price <= filterPrice[1];
   // const inBrand = filterBrand === 'all' || p.brand_id === parseInt(filterBrand);
   // return inCategory && inPrice && inBrand;
    return inCategory && inPrice;
  });

  // Similar products for product modal
  const similarProducts = productModal 
    ? products.filter(p => p.category_id === productModal.category_id && p.id !== productModal.id).slice(0, 3)
    : [];


const pullCategories = async(category_id='',searchKey='') => {
    setLoading(true);
    

    try {
      const res = await axios.get(config.API_URL+'/api/categories/'+category_id+'/'+searchKey, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
         
        },
      });

      setProductCategories(res.data.adminCategories);
      
    } catch (err) {
      console.error('Error fetching reports:', err);
    } finally {
      setLoading(false);
    }
}


  const formatCurrency = (amount) => {
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2,
      }).format(amount);
    };
   const fetchDashboardReports = async () => {
    setMainLoading(true);
    

    try {
      const res = await axios.get(config.API_URL+'/api/dashboard_reports', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
         
        },
      });

      setDashboardReports(res.data.dashreports);
      setManagementTypes(res.data.managementTypes);
      setwebsiteManagement(res.data.websiteManagement);
      setuserManagement(res.data.userManagement);
      setorderManagement(res.data.orderManagement);
      setfinanceManagement(res.data.financeManagement);
      setsettingsManagement(res.data.settingsManagement);
       setMainLoading(false);
    } catch (err) {
      console.error('Error fetching reports:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardReports();
  }, [token]);


  /**const managementTypes = [
    { icon: Package, label: 'Products', count: '1,247', color: 'from-amber-500 to-red-500', isNew: false },
    { icon: ShoppingCart, label: 'Orders', count: '389', color: 'from-green-500 to-emerald-500', isNew: true },
    { icon: Users, label: 'Customers', count: '2,456', color: 'from-red-500 to-pink-500', isNew: false },
    { icon: BarChart3, label: 'Analytics', count: 'Live', color: 'from-orange-500 to-red-500', isNew: false },
    { icon: Star, label: 'Reviews', count: '156', color: 'from-yellow-500 to-orange-500', isNew: false },
    { icon: Settings, label: 'Settings', count: '', color: 'from-gray-500 to-slate-500', isNew: false },
    { icon: Bell, label: 'Notifications', count: '12', color: 'from-red-500 to-pink-500', isNew: true },
    { icon: TrendingUp, label: 'Reports', count: '', color: 'from-indigo-500 to-red-500', isNew: false },
    { icon: Upload, label: 'Import', count: '', color: 'from-teal-500 to-red-500', isNew: false },
    { icon: Download, label: 'Export', count: '', color: 'from-green-600 to-teal-600', isNew: false },
    { icon: AlertCircle, label: 'Alerts', count: '3', color: 'from-red-600 to-orange-600', isNew: false },
    { icon: MoreHorizontal, label: 'More', count: '', color: 'from-gray-400 to-gray-600', isNew: false }
  ];**/

  const recentActivities = [
    {
      id: 1,
      title: 'New Product Added',
      description: 'iPhone 15 Pro Max - Space Black',
      thumbnail: 'https://images.unsplash.com/photo-1592750475338-74b7b21085ab?w=300&h=200&fit=crop',
      gradient: 'from-amber-600 to-red-600',
      status: 'Active',
      time: '2 hours ago'
    },
    {
      id: 2,
      title: 'Order #ORD-12458',
      description: 'Customer: Sarah Johnson - $1,299.99',
      thumbnail: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=300&h=200&fit=crop',
      gradient: 'from-green-500 to-emerald-600',
      status: 'Processing',
      time: '45 minutes ago'
    },
    {
      id: 3,
      title: 'Inventory Alert',
      description: 'Low stock: MacBook Air M2 (5 units left)',
      thumbnail: 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=300&h=200&fit=crop',
      gradient: 'from-orange-500 to-red-500',
      status: 'Alert',
      time: '1 hour ago'
    },
    {
      id: 4,
      title: 'Customer Review',
      description: '5-star review for Wireless Headphones',
      thumbnail: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=300&h=200&fit=crop',
      gradient: 'from-yellow-500 to-orange-500',
      status: 'New',
      time: '3 hours ago'
    }
  ];

 
  const sidebarItems = [
    { icon: Home, label: 'Dashboard', active: true },
    { icon: Users, label: 'Addresses' },
    { icon: Settings, label: 'Settings' }
  ];









 

  // Sample product data matching the categories from your image
  const [productz] = useState([
    { id: 1, name: 'Campaign Caps Premium', category: 'Campaign Caps', parentCategory: 'Caps', price: 1250, stock: 15, image: '🧢', status: 'Active' },
    { id: 2, name: 'Kichungi Plain Caps Standard', category: 'Kichungi Plain Caps', parentCategory: 'Caps', price: 850, stock: 32, image: '🧢', status: 'Active' },
    { id: 3, name: 'Kichungi Plain Caps Deluxe', category: 'Kichungi Plain Caps', parentCategory: 'Caps', price: 1100, stock: 18, image: '🧢', status: 'Active' },
    { id: 4, name: 'Polyester 5 Panel Plain', category: 'Polyester 5 Panel Plain Caps', parentCategory: 'Caps', price: 950, stock: 8, image: '🧢', status: 'Low Stock' },
    { id: 5, name: 'Polyester 5 Panel Premium', category: 'Polyester 5 Panel Plain Caps', parentCategory: 'Caps', price: 1300, stock: 12, image: '🧢', status: 'Active' },
    { id: 6, name: '6-panel Polyester Standard', category: '6-panel Polyester Caps', parentCategory: 'Caps', price: 750, stock: 25, image: '🧢', status: 'Active' },
    { id: 7, name: '6-panel Polyester Premium', category: '6-panel Polyester Caps', parentCategory: 'Caps', price: 1050, stock: 14, image: '🧢', status: 'Active' },
    { id: 8, name: 'Campaign Caps Limited Edition', category: 'Campaign Caps', parentCategory: 'Caps', price: 1500, stock: 5, image: '🧢', status: 'Low Stock' },
  ]);

  

  const filteredProducts = selectedCategory === 'all' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getStatusBadge = (stock) => {
    const baseClass = "px-2 py-1 text-xs font-medium rounded-full";
    if (stock > 10) {
      return `${baseClass} bg-green-100 text-green-800`;
    } else if (stock < 10  ) {
      return `${baseClass} bg-yellow-100 text-yellow-800`;
    }
    else if (stock < 5 ) {
      return `${baseClass} bg-red-100 text-red-800`;
    }
    return `${baseClass} bg-gray-100 text-gray-800`;
  };


  const CategoryCard = ({ category }) => (
    <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100 mb-3">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center flex-1">
          <img 
            style={{ width: '40px', height: '40px' }} 
            className="border border-gray-100 rounded-lg mr-3 object-cover" 
            src={category.icon || 'https://admins.junisaproducts.com/assets/images/icons/snacks.svg'} 
            alt={category.name}
          />
          <div className="flex-1">
            <h3 
              className="font-medium text-blue-900 text-sm cursor-pointer hover:text-blue-700"
              onClick={() => getChildCategories(category.id)}
            >
              {category.name}
            </h3>
            <p className="text-xs text-blue-600 mt-1">
              View ({category.category_items})
            </p>
          </div>
        </div>
        
        <div className="flex space-x-2 ml-2">
          <button
            onClick={() => editCategory(category.id)}
            className="p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
          >
            <Edit className="h-4 w-4" />
          </button>
          <button
            onClick={() => deleteCategory(category.id)}
            className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
          >
            <Trash2 className="h-4 w-4" />
          </button>
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-4 pt-3 border-t border-gray-100">
        <div>
          <p className="text-xs text-gray-500 mb-1">Parent Category</p>
          <p className="font-medium text-sm text-gray-900">{category.parent_category}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500 mb-1">Products</p>
          <p className="font-medium text-sm text-gray-900">{category.product_count}</p>
        </div>
      </div>
    </div>
  );


  const ProductCard = ({ product }) => (
    <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-200 mb-3">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center">
          <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center text-lg mr-3">
            {product.image_url}
          </div>
          <div>
            <h3 className="font-medium text-gray-900 text-sm">{product.name}</h3>
            <p className="text-xs text-gray-500">{product.category_name}</p>
          </div>
        </div>
        <span className={getStatusBadge(product.stock)}>{product.status}</span>
      </div>
      
      <div className="grid grid-cols-3 gap-4 pt-3 border-t border-gray-100">
        <div>
          <p className="text-xs text-gray-500 mb-1">Price</p>
          <p className="font-semibold text-sm">Ksh {product.price.toLocaleString()}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500 mb-1">Stock</p>
          <p className="font-semibold text-sm">{product.stock}</p>
        </div>
        <div className="flex justify-end space-x-2">
          <button className="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
            </svg>
          </button>
          <button className="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );



  if (mainloading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-amber-50 via-red-50 to-pink-50 flex items-center justify-center p-4">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
          <p className="text-base text-gray-600 font-medium">Setting up your dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-red-50 to-pink-50 ">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-md border-b border-red-100 sticky top-0 z-50">
        <div className="flex items-center justify-between px-4 lg:px-6 py-4">
          <div className="flex items-center space-x-4">
            <button 
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="p-2 hover:bg-red-100 rounded-lg transition-colors lg:hidden"
            >
              <Menu className="w-5 h-5 text-gray-600" />
            </button>
            <button className="p-2 hover:bg-red-100 rounded-lg transition-colors hidden lg:block">
              <Menu className="w-5 h-5 text-gray-600" />
            </button>
            <div className="text-xl lg:text-2xl font-bold bg-gradient-to-r from-amber-600 to-red-600 bg-clip-text text-transparent">
              LiqourMart Ke
            </div>
          </div>
          
          <div className="flex items-center space-x-2 lg:space-x-4">
            <div className="relative">
              <Bell className="w-5 h-5 lg:w-6 lg:h-6 text-gray-600 hover:text-red-600 cursor-pointer transition-colors" />
              <span className="absolute -top-1 -right-1 w-2 h-2 lg:w-3 lg:h-3 bg-red-500 rounded-full"></span>
            </div>
            
            <button className="flex items-center space-x-1 lg:space-x-2 bg-gradient-to-r from-amber-500 to-red-600 text-white px-2 lg:px-4 py-2 rounded-full hover:shadow-lg transition-all duration-300 transform hover:scale-105 text-sm lg:text-base">
              <Crown className="w-3 h-3 lg:w-4 lg:h-4" />
              <span className="font-medium hidden sm:inline">Upgrade to Pro</span>
              <span className="font-medium sm:hidden">Pro</span>
            </button>
          </div>
        </div>
      </header>

      <div className="flex relative">
        {/* Mobile Sidebar Overlay */}
        {sidebarOpen && (
          <div 
            className="fixed inset-0 bg-black/50 z-40 lg:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* Sidebar */}
        <aside className={`
          ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0
          fixed lg:sticky top-16 lg:top-16 left-0 z-50
          w-64 lg:w-20 bg-white/90 lg:bg-white/60 backdrop-blur-sm border-r border-red-100 
          h-[calc(100vh-4rem)] transition-transform duration-300 ease-in-out
        `}>
          {/* Mobile sidebar header */}
          <div className="lg:hidden flex items-center justify-between p-4 border-b border-red-100">
            <span className="font-semibold text-gray-800">Menu</span>
            <button 
              onClick={() => setSidebarOpen(false)}
              className="p-2 hover:bg-red-100 rounded-lg transition-colors"
            >
              <X className="w-5 h-5 text-gray-600" />
            </button>
          </div>

          <nav className="p-4 space-y-6">
            {/* Add New Button */}
            <div className="flex flex-col items-center space-y-2 lg:items-center">
              <div className="w-12 h-12 bg-gradient-to-r from-amber-500 to-red-500 rounded-full flex items-center justify-center text-white">
                <Plus className="w-6 h-6" />
              </div>
              <span className="text-xs font-medium text-red-600 lg:block">Add</span>
            </div>
            
            {/* Navigation Items */}
            {sidebarItems?.map((item, index) => (
              <div key={index} className="flex lg:flex-col items-center lg:items-center space-x-3 lg:space-x-0 lg:space-y-2 group cursor-pointer">
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center transition-all duration-300 ${
                  item.active 
                    ? 'bg-gradient-to-r from-amber-500 to-red-500 text-white shadow-lg' 
                    : 'hover:bg-red-100 text-gray-600 group-hover:text-red-600'
                }`}>
                  <item.icon className="w-5 h-5" />
                </div>
                <span className={`text-sm lg:text-xs font-medium lg:text-center ${
                  item.active ? 'text-red-600' : 'text-gray-500 group-hover:text-red-600'
                }`}>
                  {item.label}
                </span>
              </div>
            ))}
          </nav>
        </aside>

        {/* Main Content */}
        <main className="flex-1 p-4 lg:p-8 lg:ml-20 mx-auto px-4">
          {/* Hero Section */}
          <div className="text-center mb-8 lg:mb-12">
            <h1 className="text-3xl lg:text-5xl font-bold bg-gradient-to-r from-amber-600 via-red-600 to-pink-600 bg-clip-text text-transparent mb-2 lg:mb-4">
              E-commerce Dashboard
            </h1>
            <p className="text-gray-600 text-sm lg:text-lg mb-6 lg:mb-8">Manage your online store with powerful tools and insights</p>
            
            {/* Stats Cards */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-6 mb-6 lg:mb-8">
              {stats?.map((stat, index) => (
                <div key={index} className="bg-white/80 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-white/50">
                  <div className="text-lg lg:text-2xl font-bold text-gray-800">
                  {stat.label === 'Total Orders' ? (stat.value || '-') : formatCurrency(stat.value)}
                  </div>
                  <div className="text-gray-600 text-xs lg:text-sm mb-1 lg:mb-2">{stat.label}</div>
                  <div className={`text-xs lg:text-sm font-medium ${stat.positive ? 'text-green-600' : 'text-red-600'}`}>
                    {stat.change}
                  </div>
                </div>
              ))}
            </div>

            {/* Navigation Tabs */}
            <div className="flex justify-center space-x-4 lg:space-x-8 mb-6 lg:mb-8 overflow-x-auto">
              <button 
                onClick={() => setActiveTab('overview')}
                className={`flex items-center space-x-2 px-3 lg:px-4 py-2 rounded-full transition-colors whitespace-nowrap ${
                  activeTab === 'overview' ? 'bg-red-100 text-red-600' : 'text-gray-600 hover:text-red-600'
                }`}
              >
                <Home className="w-4 h-4 lg:w-5 lg:h-5" />
                <span className="font-medium text-sm lg:text-base">Overview</span>
              </button>
              <button 
                onClick={() => filterActiveTab('Products')}
                className={`flex items-center space-x-2 px-3 lg:px-4 py-2 rounded-full transition-colors whitespace-nowrap ${
                  activeTab === 'products' ? 'bg-red-100 text-red-600' : 'text-gray-600 hover:text-red-600'
                }`}
              >
                <Package className="w-4 h-4 lg:w-5 lg:h-5" />
                <span className="font-medium text-sm lg:text-base">Products</span>
              </button>
              <button 
                onClick={() => setActiveTab('analytics')}
                className={`flex items-center space-x-2 px-3 lg:px-4 py-2 rounded-full transition-colors whitespace-nowrap ${
                  activeTab === 'analytics' ? 'bg-red-100 text-red-600' : 'text-gray-600 hover:text-red-600'
                }`}
              >
                <BarChart3 className="w-4 h-4 lg:w-5 lg:h-5" />
                <span className="font-medium text-sm lg:text-base">Analytics</span>
              </button>
            </div>

            {/* Search Bar */}
            <div className="max-w-2xl mx-auto relative">
              <div className="relative">
                <Search className="absolute left-3 lg:left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4 lg:w-5 lg:h-5" />
                <input
                  type="text"
                  placeholder="Search here..."
                  value={searchQuery}
                  onChange={(e) => setFilterSearchQuery(e.target.value)}
                  className="w-full pl-10 lg:pl-12 pr-10 lg:pr-12 py-3 lg:py-4 bg-white/80 backdrop-blur-sm border border-red-200 rounded-xl lg:rounded-2xl focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent shadow-lg hover:shadow-xl transition-all duration-300 text-sm lg:text-base"
                />
                <button className="absolute right-3 lg:right-4 top-1/2 transform -translate-y-1/2 text-red-500 hover:text-red-600">
                  <Filter className="w-4 h-4 lg:w-5 lg:h-5" />
                </button>
              </div>
            </div>
          </div>


{activeTab==='product_view' && (

<div className='bg-gradient-to-br from-amber-50 via-red-50 to-amber-50'>
      <div style={{
       
        padding: isMobile ? '20px' : '40px',
        minHeight: 'calc(100vh - 80px)',
      }}>
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Manage Products</h1>
          <p className="text-gray-600">Manage your liquor inventory with powerful tools and insights</p>
        </div>

        {/* Category Filter Tabs */}
        <div className="mb-6">
          <div className="flex flex-wrap gap-2 bg-white p-4 rounded-lg shadow-sm border border-gray-200">
            {paginatedCategories?.map((category) => (
              <button
                key={category.name}
                onClick={() => setSelectedCategory(category.name)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  selectedCategory === category.name
                    ? 'bg-orange-500 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category.name} ({category.category_items})
              </button>
            ))}
          </div>
        </div>

        {/* Search Bar */}
        <div className="mb-6">
          <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200">
            <input
              type="text"
              placeholder="Search products..."
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
            />
          </div>
        </div>

        {/* Mobile View - Cards */}
        {isMobile ? (
          <div>
            {filteredViewAllProducts?.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        ) : (
          /* Desktop View - Table */
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th className="text-left py-4 px-6 font-semibold text-gray-700 text-sm">PRODUCT</th>
                    <th className="text-left py-4 px-6 font-semibold text-gray-700 text-sm">CATEGORY</th>
                    <th className="text-left py-4 px-6 font-semibold text-gray-700 text-sm">PARENT CATEGORY</th>
                    <th className="text-left py-4 px-6 font-semibold text-gray-700 text-sm">PRICE</th>
                    <th className="text-left py-4 px-6 font-semibold text-gray-700 text-sm">STOCK</th>
                    <th className="text-left py-4 px-6 font-semibold text-gray-700 text-sm">STATUS</th>
                    <th className="text-left py-4 px-6 font-semibold text-gray-700 text-sm">ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredProducts?.map((product) => (
                    <tr key={product.id} className="border-b border-gray-100 hover:bg-gray-50">
                      <td className="py-4 px-6">
                        <div className="flex items-center">
                          <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center text-lg mr-3">
                           <img src={product.image_url} alt={product.name} className="w-16 h-16 object-cover rounded-lg" />
                          </div>
                          <div>
                            <p className="font-medium text-gray-900">{product.name}</p>
                            <p className="text-sm text-gray-500">ID: {product.id}</p>
                          </div>
                        </div>
                      </td>
                      <td className="py-4 px-6 text-gray-700">{product.category}</td>
                      <td className="py-4 px-6 text-gray-700">{product.parentCategory}</td>
                      <td className="py-4 px-6 font-semibold text-gray-900">Ksh {product.price.toLocaleString()}</td>
                      <td className="py-4 px-6 text-gray-700">{product.stock}</td>
                      <td className="py-4 px-6">
                        <span className={getStatusBadge(product.status)}>
                          {product.status}
                        </span>
                      </td>
                      <td className="py-4 px-6">
                        <div className="flex space-x-2">
                          <button className="p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                            </svg>
                          </button>
                          <button className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Stats Summary */}
        <div className="mt-6 grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
            <h3 className="text-2xl font-bold text-gray-900">{products.length}</h3>
            <p className="text-gray-600">Total Products</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
            <h3 className="text-2xl font-bold text-green-600">
              {products.filter(p => p.status === 'Active').length}
            </h3>
            <p className="text-gray-600">Active Products</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
            <h3 className="text-2xl font-bold text-yellow-600">
              {products.filter(p => p.status === 'Low Stock').length}
            </h3>
            <p className="text-gray-600">Low Stock Items</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
            <h3 className="text-2xl font-bold text-gray-900">
              Ksh {products.reduce((sum, p) => sum + (p.price * p.stock), 0).toLocaleString()}
            </h3>
            <p className="text-gray-600">Total Inventory Value</p>
          </div>
        </div>
      </div>
    </div>


)}

{activeTab === 'product_categories' && (
  <div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-100">
            <div className="p-6">
              {loading ? (
                <div className="text-center py-8">Loading...</div>
              ) : paginatedCategories.length > 0 ? (
                <div>
                  {/* Header */}
                  <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center">
                      <button
                        onClick={() => filterActiveTab('Categories')}
                        className="bg-amber-500 text-white px-4 py-2 rounded-lg hover:bg-amber-600 flex items-center space-x-2 transition-colors"
                      >
                        <ChevronLeft className="h-4 w-4" />
                        <span className='backMenuLabel'>Back</span>
                      </button>
                      <div>
                        <h1 className="text-xl md:text-2xl font-bold text-gray-900 ml-4">
                          Manage Categories
                        </h1>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="overflow-x-auto" ref={tableRef}>
                    {/* Mobile View - Cards */}
                    {isMobile ? (
                      <div className="space-y-3">
                        {paginatedCategories?.map(category => (
                          <CategoryCard key={category.id} category={category} />
                        ))}
                      </div>
                    ) : (
                      /* Desktop View - Table */
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase">Name</th>
                            <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase">Parent Category</th>
                            <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase">Products</th>
                            <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase">Actions</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                          {paginatedCategories?.map(category => (
                            <tr key={category.id} className="hover:bg-gray-50">
                              <td className="px-6 py-4 text-sm text-blue-900">
                                <div className="flex items-center cursor-pointer" onClick={() => getChildCategories(category.id)}>
                                  <img 
                                    style={{ width: '30px', height: '30px' }} 
                                    className="border border-gray-100 rounded" 
                                    src={category.icon || 'https://admins.junisaproducts.com/assets/images/icons/snacks.svg'} 
                                    alt={category.name}
                                  />
                                  <div className="ml-3">
                                    <h3 className="font-medium">{category.name}</h3>
                                    <p className="text-blue-600 text-xs mt-1">View ({category.category_items})</p>
                                  </div>
                                </div>
                              </td>
                              <td className="px-6 py-4 text-sm text-gray-900">{category.parent_category}</td>
                              <td className="px-6 py-4 text-sm text-gray-900">{category.product_count}</td>
                              <td className="px-6 py-4 text-sm">
                                <div className="flex space-x-2">
                                  <button
                                    onClick={() => editCategory(category.id)}
                                    className="text-blue-600 hover:text-blue-800 p-1 rounded"
                                  >
                                    <Edit className="h-4 w-4" />
                                  </button>
                                  <button
                                    onClick={() => deleteCategory(category.id)}
                                    className="text-red-600 hover:text-red-800 p-1 rounded"
                                  >
                                    <Trash2 className="h-4 w-4" />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>

                  {/* Pagination */}
                  <div className="px-4 py-3 bg-slate-50 border-t border-slate-200 mt-6">
                    <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
                      <div className="flex items-center gap-2 text-sm">
                        <span className="text-slate-600">Show</span>
                        <select
                          value={itemsPerPage}
                          onChange={(e) => {
                            setItemsPerPage(Number(e.target.value));
                            setCurrentPage(1);
                          }}
                          className="px-2 py-1 border border-slate-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none text-sm"
                        >
                          <option value={5}>5</option>
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                          <option value={50}>50</option>
                        </select>
                        <span className="text-slate-600">entries</span>
                      </div>

                      <div className="text-sm text-slate-600">
                        Showing {startIndex + 1} to {Math.min(startIndex + itemsPerPage, filteredCategories.length)} of {filteredCategories.length} entries
                      </div>

                      <div className="flex items-center gap-1">
                        <button
                          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                          disabled={currentPage === 1}
                          className="flex items-center gap-1 px-3 py-1 border border-slate-300 rounded hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed text-sm transition-colors"
                        >
                          <ChevronLeft className="w-4 h-4" />
                          <span className="hidden sm:inline">Prev</span>
                        </button>

                        <div className="flex gap-1">
                          {(() => {
                            const maxVisible = isMobile ? 2 : 3;
                            let start = Math.max(currentPage - Math.floor(maxVisible / 2), 1);
                            let end = Math.min(start + maxVisible - 1, totalPages);
                            if (end - start + 1 < maxVisible) {
                              start = Math.max(end - maxVisible + 1, 1);
                            }

                            return Array.from({ length: end - start + 1 }, (_, i) => start + i)?.map(pageNum => (
                              <button
                                key={pageNum}
                                onClick={() => setCurrentPage(pageNum)}
                                className={`w-8 h-8 rounded text-sm font-medium transition-colors ${
                                  currentPage === pageNum
                                    ? 'bg-blue-600 text-white'
                                    : 'border border-slate-300 hover:bg-slate-100 text-slate-700'
                                }`}
                              >
                                {pageNum}
                              </button>
                            ));
                          })()}
                        </div>

                        <button
                          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                          disabled={currentPage === totalPages}
                          className="flex items-center gap-1 px-3 py-1 border border-slate-300 rounded hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed text-sm transition-colors"
                        >
                          <span className="hidden sm:inline">Next</span>
                          <ChevronRight className="w-4 h-4" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

              ) : (
                <div>
                  {/* Header for empty state */}
                  <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center">
                      <button
                        onClick={() => filterActiveTab('Categories')}
                        className="bg-amber-500 text-white px-4 py-2 rounded-lg hover:bg-amber-600 flex items-center space-x-2 transition-colors"
                      >
                        <ChevronLeft className="h-4 w-4" />
                        <span className='backMenuLabel'>Back</span>
                      </button>
                      <div>
                        <h1 className="text-xl md:text-2xl font-bold text-gray-900 ml-4">
                          Manage Categories
                        </h1>
                      </div>
                    </div>
                  </div>
                  
                  <div className="text-center py-8 text-gray-600">
                    <div className="mb-4">
                      <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                      </svg>
                    </div>
                    No categories found
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
  )}



{activeTab === 'overview' && (
  <div>
          {/* Management Type Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 mb-12 lg:mb-16">
     
      <div className="bg-white/80 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 border border-white/50">
     <h3 className="font-semibold mb-5 text-gray-800 text-start group-hover:text-red-600 transition-colors text-md lg:text-base">
          Product Management
        </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 lg:gap-6 mb-12 lg:mb-16">
            
            {managementTypes?.map((type, index) => {
  const IconComponent = iconMap[type.icon];

  return (
    <div key={index} className="relative group cursor-pointer"   onClick={() => filterActiveTab(type.label)}>
      <div className="bg-white/80 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 border border-white/50">
        {type.isNew && (
          <div className="absolute -top-1 -right-1 lg:-top-2 lg:-right-2 bg-gradient-to-r from-green-500 to-emerald-500 text-white text-xs px-1.5 lg:px-2 py-0.5 lg:py-1 rounded-full font-bold shadow-lg">
            New
          </div>
        )}
        
          <div className="absolute -top-1 -left-1 lg:-top-2 lg:-left-2 bg-gradient-to-r from-amber-500 to-red-500 text-white text-xs px-1.5 lg:px-2 py-0.5 lg:py-1 rounded-full font-bold shadow-lg">
            {type.count}
          </div>
       <center>
        <div className={`w-12 h-12 lg:w-16 lg:h-16 rounded-xl lg:rounded-2xl bg-gradient-to-br ${type.color} flex items-center justify-center mb-3 lg:mb-4 group-hover:scale-110 transition-transform duration-300`}>
          {IconComponent && <IconComponent className="w-6 h-6 lg:w-8 lg:h-8 text-white" />}
        </div>
        <h3 className="text-gray-800 text-center group-hover:text-red-600 transition-colors text-sm lg:text-base" style={{fontSize:'11px'}}>
          {type.label}
        </h3>
        </center>
      </div>
    </div>
  );
})}

          </div>
          </div>
          <div className="bg-white/80 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 border border-white/50">
     <h3 className="font-semibold mb-5 text-gray-800 text-start group-hover:text-red-600 transition-colors text-md lg:text-base">
          Order Management
        </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 lg:gap-6 mb-12 lg:mb-16">
            {orderManagement?.map((type, index) => {
  const IconComponent = iconMap[type.icon];

  return (
    <div key={index} className="relative group cursor-pointer">
      <div className="bg-white/80 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 border border-white/50">
        {type.isNew && (
          <div className="absolute -top-1 -right-1 lg:-top-2 lg:-right-2 bg-gradient-to-r from-green-500 to-emerald-500 text-white text-xs px-1.5 lg:px-2 py-0.5 lg:py-1 rounded-full font-bold shadow-lg">
            New
          </div>
        )}
        
          <div className="absolute -top-1 -left-1 lg:-top-2 lg:-left-2 bg-gradient-to-r from-amber-500 to-red-500 text-white text-xs px-1.5 lg:px-2 py-0.5 lg:py-1 rounded-full font-bold shadow-lg">
            {type.count}
          </div>
       
        <center>
        <div className={`w-12 h-12 lg:w-16 lg:h-16 rounded-xl lg:rounded-2xl bg-gradient-to-br ${type.color} flex items-center justify-center mb-3 lg:mb-4 group-hover:scale-110 transition-transform duration-300`}>
          {IconComponent && <IconComponent className="w-6 h-6 lg:w-8 lg:h-8 text-white" />}
        </div>
        <h3 className="text-gray-800 text-center group-hover:text-red-600 transition-colors text-sm lg:text-base" style={{fontSize:'11px'}}>
          {type.label}
        </h3>
        </center>
      </div>
    </div>
  );
})}

          </div>
          </div>
          <div className="bg-white/80 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 border border-white/50">
     <h3 className="font-semibold mb-5 text-gray-800 text-start group-hover:text-red-600 transition-colors text-md lg:text-base">
          Website Management
        </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 lg:gap-6 mb-12 lg:mb-16">
            {websiteManagement?.map((type, index) => {
  const IconComponent = iconMap[type.icon];

  return (
    <div key={index} className="relative group cursor-pointer">
      <div className="bg-white/80 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 border border-white/50">
        {type.isNew && (
          <div className="absolute -top-1 -right-1 lg:-top-2 lg:-right-2 bg-gradient-to-r from-green-500 to-emerald-500 text-white text-xs px-1.5 lg:px-2 py-0.5 lg:py-1 rounded-full font-bold shadow-lg">
            New
          </div>
        )}
        
          <div className="absolute -top-1 -left-1 lg:-top-2 lg:-left-2 bg-gradient-to-r from-amber-500 to-red-500 text-white text-xs px-1.5 lg:px-2 py-0.5 lg:py-1 rounded-full font-bold shadow-lg">
            {type.count}
          </div>
       
        <center>
        <div className={`w-12 h-12 lg:w-16 lg:h-16 rounded-xl lg:rounded-2xl bg-gradient-to-br ${type.color} flex items-center justify-center mb-3 lg:mb-4 group-hover:scale-110 transition-transform duration-300`}>
          {IconComponent && <IconComponent className="w-6 h-6 lg:w-8 lg:h-8 text-white" />}
        </div>
        <h3 className="text-gray-800 text-center group-hover:text-red-600 transition-colors text-sm lg:text-base" style={{fontSize:'11px'}}>
          {type.label}
        </h3>
        </center>
      </div>
    </div>
  );
})}

          </div>
          </div>

<div className="bg-white/80 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 border border-white/50">
     <h3 className="font-semibold mb-5 text-gray-800 text-start group-hover:text-red-600 transition-colors text-md lg:text-base">
          User Management
        </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 lg:gap-6 mb-12 lg:mb-16">
            {userManagement?.map((type, index) => {
  const IconComponent = iconMap[type.icon];

  return (
    <div key={index} className="relative group cursor-pointer">
      <div className="bg-white/80 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 border border-white/50">
        {type.isNew && (
          <div className="absolute -top-1 -right-1 lg:-top-2 lg:-right-2 bg-gradient-to-r from-green-500 to-emerald-500 text-white text-xs px-1.5 lg:px-2 py-0.5 lg:py-1 rounded-full font-bold shadow-lg">
            New
          </div>
        )}
        
          <div className="absolute -top-1 -left-1 lg:-top-2 lg:-left-2 bg-gradient-to-r from-amber-500 to-red-500 text-white text-xs px-1.5 lg:px-2 py-0.5 lg:py-1 rounded-full font-bold shadow-lg">
            {type.count}
          </div>
       
        <center>
        <div className={`w-12 h-12 lg:w-16 lg:h-16 rounded-xl lg:rounded-2xl bg-gradient-to-br ${type.color} flex items-center justify-center mb-3 lg:mb-4 group-hover:scale-110 transition-transform duration-300`}>
          {IconComponent && <IconComponent className="w-6 h-6 lg:w-8 lg:h-8 text-white" />}
        </div>
        <h3 className="text-gray-800 text-center group-hover:text-red-600 transition-colors text-sm lg:text-base" style={{fontSize:'11px'}}>
          {type.label}
        </h3>
        </center>
      </div>
    </div>
  );
})}

          </div>
          </div>


          <div className="bg-white/80 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 border border-white/50">
     <h3 className="font-semibold mb-5 text-gray-800 text-start group-hover:text-red-600 transition-colors text-md lg:text-base">
          Accounting Reports
        </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 lg:gap-6 mb-12 lg:mb-16">
            {financeManagement?.map((type, index) => {
  const IconComponent = iconMap[type.icon];

  return (
    <div key={index} className="relative group cursor-pointer">
      <div className="bg-white/80 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 border border-white/50">
        {type.isNew && (
          <div className="absolute -top-1 -right-1 lg:-top-2 lg:-right-2 bg-gradient-to-r from-green-500 to-emerald-500 text-white text-xs px-1.5 lg:px-2 py-0.5 lg:py-1 rounded-full font-bold shadow-lg">
            New
          </div>
        )}
        
          <div className="absolute -top-1 -left-1 lg:-top-2 lg:-left-2 bg-gradient-to-r from-amber-500 to-red-500 text-white text-xs px-1.5 lg:px-2 py-0.5 lg:py-1 rounded-full font-bold shadow-lg">
            {type.count}
          </div>
       
         <center>
        <div className={`w-12 h-12 lg:w-16 lg:h-16 rounded-xl lg:rounded-2xl bg-gradient-to-br ${type.color} flex items-center justify-center mb-3 lg:mb-4 group-hover:scale-110 transition-transform duration-300`}>
          {IconComponent && <IconComponent className="w-6 h-6 lg:w-8 lg:h-8 text-white" />}
        </div>
        <h3 className="text-gray-800 text-center group-hover:text-red-600 transition-colors text-sm lg:text-base" style={{fontSize:'11px'}}>
          {type.label}
        </h3>
        </center>
      </div>
    </div>
  );
})}

          </div>
          </div>


<div className="bg-white/80 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 border border-white/50">
     <h3 className="font-semibold mb-5 text-gray-800 text-start group-hover:text-red-600 transition-colors text-md lg:text-base">
         System Settings
        </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 lg:gap-6 mb-12 lg:mb-16">
            {settingsManagement?.map((type, index) => {
  const IconComponent = iconMap[type.icon];

  return (
    <div key={index} className="relative group cursor-pointer">
      <div className="bg-white/80 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 border border-white/50">
        {type.isNew && (
          <div className="absolute -top-1 -right-1 lg:-top-2 lg:-right-2 bg-gradient-to-r from-green-500 to-emerald-500 text-white text-xs px-1.5 lg:px-2 py-0.5 lg:py-1 rounded-full font-bold shadow-lg">
            New
          </div>
        )}
        
          <div className="absolute -top-1 -left-1 lg:-top-2 lg:-left-2 bg-gradient-to-r from-amber-500 to-red-500 text-white text-xs px-1.5 lg:px-2 py-0.5 lg:py-1 rounded-full font-bold shadow-lg">
            {type.count}
          </div>
       
        <center>
        <div className={`w-12 h-12 lg:w-16 lg:h-16 rounded-xl lg:rounded-2xl bg-gradient-to-br ${type.color} flex items-center justify-center mb-3 lg:mb-4 group-hover:scale-110 transition-transform duration-300`}>
          {IconComponent && <IconComponent className="w-6 h-6 lg:w-8 lg:h-8 text-white" />}
        </div>
        <h3 className="text-gray-800 text-center group-hover:text-red-600 transition-colors text-sm lg:text-base" style={{fontSize:'11px'}}>
          {type.label}
        </h3>
        </center>
      </div>
    </div>
  );
})}

          </div>
          </div>


          </div>
</div>
)}

{activeTab === 'overview' && (
        
          <div>
            <div className="flex justify-between items-center mb-6 lg:mb-8">
              <h2 className="text-2xl lg:text-3xl font-bold text-gray-800">Recent Activities</h2>
              <button className="text-red-600 hover:text-red-700 font-medium flex items-center space-x-2 text-sm lg:text-base">
                <span>View all</span>
                <ArrowRight className="w-3 h-3 lg:w-4 lg:h-4" />
              </button>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8">
              {recentActivities?.map((activity) => (
                <div key={activity.id} className="group cursor-pointer">
                  <div className="bg-white/80 backdrop-blur-sm rounded-xl lg:rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 border border-white/50">
                    <div className="aspect-[4/3] relative overflow-hidden">
                      <div className={`absolute inset-0 bg-gradient-to-br ${activity.gradient} opacity-20`}></div>
                      <img 
                        src={activity.thumbnail} 
                        alt={activity.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute top-2 lg:top-3 right-2 lg:right-3">
                        <span className={`px-2 py-1 rounded-full text-xs font-bold ${
                          activity.status === 'Active' ? 'bg-green-500 text-white' :
                          activity.status === 'Processing' ? 'bg-amber-500 text-white' :
                          activity.status === 'Alert' ? 'bg-red-500 text-white' :
                          'bg-yellow-500 text-white'
                        }`}>
                          {activity.status}
                        </span>
                      </div>
                    </div>
                    <div className="p-3 lg:p-4">
                      <h3 className="font-semibold text-gray-800 group-hover:text-red-600 transition-colors mb-1 text-sm lg:text-base">
                        {activity.title}
                      </h3>
                      <p className="text-xs lg:text-sm text-gray-600 mb-2 line-clamp-2">{activity.description}</p>
                      <div className="flex justify-between items-center">
                        <span className="text-xs text-gray-500">{activity.time}</span>
                        <div className="flex space-x-2">
                          <button className="text-gray-500 hover:text-red-600 transition-colors">
                            <Eye className="w-3 h-3 lg:w-4 lg:h-4" />
                          </button>
                          <button className="text-gray-500 hover:text-amber-600 transition-colors">
                            <Edit className="w-3 h-3 lg:w-4 lg:h-4" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

           )}
        </main>
      </div>

     

      {/* Floating Action Button */}
      <div className="fixed bottom-4 lg:bottom-8 right-4 lg:right-8">
        <button className="w-12 h-12 lg:w-16 lg:h-16 bg-gradient-to-r from-amber-500 to-red-500 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-300 flex items-center justify-center text-white">
          <Plus className="w-6 h-6 lg:w-8 lg:h-8" />
        </button>
      </div>
    </div>
  );
};

export default EcommerceBackend;